// SEO landing pages data — one file per service for the Saudi freelance market.
// Each entry maps to a dedicated route like /logo-design-pricing-saudi.
// Content is in Arabic (primary market) and ~800-1100 words each + FAQ schema.

const SITE = "https://prolancer.app";

export const LANDING_PAGES = {
  "prolancer-pricing-calculator": {
    slug: "prolancer-pricing-calculator",
    service: "all",
    h1: "كيف أسعّر خدماتي كمستقل في السعودية؟ · حاسبة أسعار العمل الحر",
    metaTitle: "حاسبة أسعار العمل الحر في السعودية | برولانسر",
    metaDesc: "كيف أسعّر خدماتي كمستقل أو فريلانسر في السعودية؟ حاسبة أسعار العمل الحر من برولانسر تعطيك سعرًا مبنيًا على السوق السعودي خلال ثوانٍ — مع اقتراحات ذكاء اصطناعي.",
    kw: "حاسبة أسعار العمل الحر, كيف أسعر خدماتي, حاسبة تسعير, عمل حر, فريلانسر",
    tagline: "دليلك الكامل لتسعير خدمات العمل الحر في المملكة",
    priceTable: [
      { role: "مستقل مبتدئ", perHour: "40–80 ريال" },
      { role: "مستقل متوسط", perHour: "80–180 ريال" },
      { role: "مستقل خبير", perHour: "180–400 ريال" },
      { role: "استشاري متخصص", perHour: "400–900 ريال" },
    ],
    sections: [
      {
        h: "لماذا تحتاج حاسبة أسعار العمل الحر؟",
        p: "أكثر من 70% من المستقلين السعوديين يسعّرون خدماتهم بالتخمين أو بمقارنة عشوائية مع منافسين لا يعرفونهم جيدًا. النتيجة: إما سعر منخفض يحرقك ماديًا ويقتل ساعاتك، أو سعر مرتفع يبعد العميل قبل أن يفتح الرسالة. حاسبة أسعار العمل الحر من برولانسر تحوّل هذا التخمين إلى معادلة مبنية على بيانات حقيقية من السوق السعودي 2026، مع ثلاث خيارات سعرية: سعر الفوز بالطلب، السعر الموصى به، وسعر القيمة العالية.",
      },
      {
        h: "ما العوامل التي تحدد سعر خدمتك؟",
        p: "التسعير الاحترافي يعتمد على 5 عوامل رئيسية: (1) نوع الخدمة ومستوى الطلب عليها في السوق، (2) خبرتك المثبتة بمعرض أعمال وشهادات، (3) تعقيد المشروع بين بسيط ومتوسط ومعقد، (4) الوقت المطلوب لإنجازه بما يشمل التعديلات، و(5) الاستعجال في التسليم. الحاسبة تطبق معاملات دقيقة على كل عامل وتخرج لك سعر الساعة والمشروع كاملًا بالريال السعودي.",
      },
      {
        h: "ما أفضل طريقة لحساب سعر المشروع؟",
        p: "الطريقة الاحترافية هي الجمع بين التسعير بالساعة والتسعير بالقيمة. بالساعة: احسب الوقت الحقيقي للتنفيذ × سعر الساعة في السوق × معامل خبرتك. بالقيمة: فكّر في العائد الذي سيحققه العميل من خدمتك (مبيعات، جمهور، كفاءة)، واطلب نسبة عادلة من هذا العائد. حاسبة برولانسر تطبق الاستراتيجيتين معًا وتعرض سعرًا نهائيًا متوازنًا — مع إمكانية التعديل اليدوي بسحب الـ Slider.",
      },
      {
        h: "خمس خطوات لاستخدام الحاسبة",
        p: "1. اختر نوع الخدمة من 8 تخصصات (تطوير مواقع، تطبيقات، تصميم، سوشال ميديا، كتابة، UI/UX، فيديو، SEO). 2. حدد مستوى خبرتك (مبتدئ/متوسط/خبير). 3. حدد تعقيد المشروع. 4. أدخل عدد الساعات أو الأيام أو حدد 'مشروع كامل'. 5. اضغط 'احصل على اقتراح ذكي' ليحلل الذكاء الاصطناعي السوق ويعرض لك ثلاثة أسعار جاهزة للنسخ أو المشاركة عبر واتساب.",
      },
      {
        h: "كم يأخذ الفريلانسر في السعودية؟",
        p: "متوسط دخل الفريلانسر السعودي الشهري يتفاوت بين 4,000 ريال للمبتدئ العامل بالساعات القليلة، إلى 25,000+ ريال للخبير بدوام كامل في تخصصات مطلوبة (تطوير برمجيات، UI/UX، تسويق أداء). الفارق الرئيسي بين الفئتين ليس المهارة فقط، بل كفاءة التسعير والقدرة على رفع السعر دون خسارة العملاء — وهذا بالضبط ما تدرّبك عليه حاسبة برولانسر.",
      },
      {
        h: "متى ترفع سعرك؟",
        p: "ارفع سعرك عندما: (1) يصبح لديك قائمة انتظار من العملاء، (2) تبدأ ترفض مشاريع لعدم توفر الوقت، (3) أنجزت 10+ مشاريع مكتملة بنفس الفئة، (4) أضفت مهارة جديدة ذات قيمة. القاعدة الذهبية: ارفع 15–25% كل ستة أشهر خلال أول سنتين من مسيرتك، ثم 10% سنويًا. الحاسبة تحتوي محرر 'أسعار السوق' لتخصيص القيم بما يناسب مستواك.",
      },
    ],
    faqs: [
      {
        q: "هل الحاسبة مجانية؟",
        a: "نعم، استخدام الحاسبة مجاني بالكامل. تحصل على 3 اقتراحات ذكاء اصطناعي مجانية شهريًا، وللمزيد تبدأ الأسعار من 5 ريالات فقط.",
      },
      {
        q: "ما مصدر أسعار السوق في الحاسبة؟",
        a: "نجمع البيانات من منصات العمل الحر السعودية، استطلاعات مستقلين حقيقيين، ومراجعات أسعار من وكالات متوسطة الحجم في الرياض وجدة والدمام — ونحدّث الأرقام شهريًا لعام 2026.",
      },
      {
        q: "هل الحاسبة تناسب كل التخصصات؟",
        a: "ندعم 8 تخصصات رئيسية (تطوير، تصميم، كتابة، تسويق، UI/UX، فيديو، SEO، تطبيقات). للتخصصات الفرعية استخدم خاصية 'تخصيص أسعار السوق' لإدخال معدلاتك.",
      },
      {
        q: "كيف أربط الحاسبة بحسابي في برولانسر؟",
        a: "بعد الحصول على السعر المقترح، اضغط 'ابدأ الآن مع برولانسر' للتسجيل مجانًا على المنصة ونشر خدمتك بالسعر الجديد خلال 3 دقائق.",
      },
      {
        q: "هل يمكنني استخدام الحاسبة داخل موقعي؟",
        a: "نعم، وفرنا كود iframe جاهز للتضمين داخل أي موقع. اضغط زر 'أدوات التكامل' في الحاسبة لنسخ الكود.",
      },
    ],
  },

  "logo-design-pricing-saudi": {
    slug: "logo-design-pricing-saudi",
    service: "graphic",
    h1: "كم سعر تصميم شعار في السعودية؟ 2026",
    metaTitle: "كم سعر تصميم شعار في السعودية؟ | حاسبة أسعار العمل الحر — برولانسر",
    metaDesc: "كم سعر تصميم شعار في السعودية 2026؟ دليل شامل لأسعار تصميم اللوغو من المستقل الفريلانسر إلى الوكالات، مع حاسبة سعر فورية بالريال السعودي.",
    kw: "كم سعر تصميم شعار, تصميم شعار السعودية, سعر لوقو, أسعار تصميم الشعارات",
    tagline: "دليل أسعار تصميم اللوغو للعلامات التجارية السعودية",
    priceTable: [
      { role: "مستقل مبتدئ", perHour: "200–600 ريال / شعار" },
      { role: "مستقل خبير", perHour: "600–2,500 ريال / شعار" },
      { role: "استوديو / وكالة", perHour: "2,500–8,000 ريال / شعار" },
      { role: "هوية بصرية كاملة", perHour: "4,000–20,000 ريال" },
    ],
    sections: [
      {
        h: "ما متوسط سعر تصميم شعار في السعودية 2026؟",
        p: "متوسط سعر تصميم شعار احترافي في المملكة لعام 2026 يتراوح بين 600 و 2,500 ريال من مستقل خبير، و 200 إلى 600 ريال من مبتدئ، و 2,500 إلى 8,000 ريال من استوديو أو وكالة متوسطة. تختلف الأسعار بناءً على: نوع الشعار (نصّي، أيقوني، مركّب)، عدد النسخ المقدَّمة، الملفات المسلّمة (AI/EPS/PNG/PDF)، وحقوق الاستخدام التجاري.",
      },
      {
        h: "ما العوامل التي تحدد سعر الشعار؟",
        p: "خمسة عوامل جوهرية: (1) خبرة المصمم ومعرض أعماله، (2) عدد الاتجاهات الأولية التي سيقدّمها (3 أو 5 أو 7)، (3) عدد التعديلات المسموحة ضمن السعر، (4) هل الشعار جزء من هوية كاملة أم منفرد، و(5) حقوق الملكية الفكرية — تصميم حصري أم شبه حصري. حاسبة أسعار العمل الحر من برولانسر تدمج كل هذه العوامل في أقل من 10 ثوانٍ.",
      },
      {
        h: "تصميم شعار بسيط أم هوية بصرية كاملة؟",
        p: "إذا كنت تطلق مشروعك الأول، اطلب شعارًا منفردًا بسعر 600–1,500 ريال وأضف باقي عناصر الهوية (بطاقة أعمال، ترويسة، سوشال ميديا كيت) لاحقًا. أما إذا كان مشروعك قائمًا ويحتاج تجديد كامل، فالهوية البصرية الشاملة بسعر 4,000–20,000 ريال توفّر وحدة بصرية وتخفّض تكلفة التعديلات المستقبلية.",
      },
      {
        h: "كم يأخذ المصمم المستقل في السعودية؟",
        p: "دخل مصمم الشعارات المستقل في المملكة يبدأ من 3,000 ريال شهريًا للمبتدئ (6–10 شعارات في الشهر بأسعار منخفضة)، ويصل إلى 25,000+ ريال للخبير (4–8 مشاريع هوية شهريًا بأسعار متوسطة وعالية). المفتاح: التركيز على قطاع محدد (مطاعم، عيادات، تقنية) وبناء معرض أعمال متخصص.",
      },
      {
        h: "كيف تستخدم الحاسبة لتسعير شعارك؟",
        p: "اختر 'تصميم جرافيك' من الحاسبة، حدد خبرتك، اختر 'متوسط' أو 'معقد' حسب تفاصيل الشعار، أدخل عدد الساعات التقديرية (6–20 ساعة للشعار النموذجي)، وفعّل خيار الاستعجال إن كان العميل يريد التسليم خلال 48 ساعة. ستحصل على ثلاثة أسعار: الفوز بالطلب، الموصى به، والمتميز — وكلها جاهزة للنسخ وإرسالها للعميل.",
      },
      {
        h: "متى تضيف رسوم إضافية؟",
        p: "أضف رسم استعجال 25–30% للتسليم أقل من 72 ساعة، رسم 15–20% لكل تعديل زائد عن المتفق عليه، 10–30% للاستخدام في عدة دول، و 20–50% لحقوق النشر الحصرية الدائمة. اذكر هذه الرسوم بوضوح في عرض السعر الذي ترسله للعميل، فالوضوح يرفع الثقة ويحسم الصفقة أسرع.",
      },
    ],
    faqs: [
      { q: "ما أرخص سعر مقبول لتصميم شعار محترف؟", a: "لا تنزل عن 300 ريال للشعار المنفرد؛ أقل من ذلك يعني غالبًا جودة ضعيفة أو شعار جاهز قد يتسبب في مشاكل حقوق." },
      { q: "كم تعديل مجاني يجب أن يشمله السعر؟", a: "المعيار المحترف 2–3 جولات تعديل داخل السعر، وكل جولة إضافية تحسب برسم 15–20%." },
      { q: "هل يختلف السعر إذا كان الشعار لمطعم مقابل تطبيق تقني؟", a: "نعم بشكل بسيط. الشعارات التقنية تحتاج تفكيرًا رمزيًا أعمق وغالبًا تسعّر 10–20% أعلى." },
      { q: "هل أدفع كامل المبلغ مقدمًا؟", a: "القاعدة في السوق السعودي: 50% دفعة أولى عند بدء التصميم و50% عند تسليم الملفات النهائية." },
      { q: "هل أحتاج عقد قبل البدء؟", a: "نعم، عقد مكتوب يوضح عدد الاقتراحات والتعديلات وحقوق الاستخدام — وتوفر برولانسر نموذج عقد جاهز لكل مشروع." },
    ],
  },

  "website-design-pricing-saudi": {
    slug: "website-design-pricing-saudi",
    service: "web_dev",
    h1: "كم سعر تصميم موقع إلكتروني في السعودية؟ 2026",
    metaTitle: "كم سعر تصميم موقع إلكتروني في السعودية؟ | حاسبة أسعار العمل الحر — برولانسر",
    metaDesc: "كم تكلفة تصميم موقع إلكتروني احترافي في السعودية 2026؟ دليل كامل لأسعار المواقع من Landing Page إلى Multi-page و WordPress و React، مع حاسبة سعر فورية.",
    kw: "كم سعر تصميم موقع, سعر موقع إلكتروني, تصميم مواقع السعودية",
    tagline: "دليل أسعار تطوير وتصميم المواقع للسوق السعودي",
    priceTable: [
      { role: "صفحة هبوط (Landing)", perHour: "1,500–4,500 ريال" },
      { role: "موقع تعريفي (5–10 صفحات)", perHour: "4,500–12,000 ريال" },
      { role: "موقع ديناميكي + CMS", perHour: "10,000–30,000 ريال" },
      { role: "تطبيق ويب متقدم / SaaS", perHour: "25,000–120,000 ريال" },
    ],
    sections: [
      {
        h: "كم تكلفة تصميم موقع إلكتروني في السعودية؟",
        p: "تكلفة تصميم موقع إلكتروني في السعودية 2026 تتفاوت بشكل كبير حسب نوع المشروع: صفحة هبوط (Landing Page) تبدأ من 1,500 ريال وتصل إلى 4,500 ريال، موقع تعريفي من 4,500 إلى 12,000 ريال، موقع ديناميكي بلوحة تحكم كاملة من 10,000 إلى 30,000 ريال، وتطبيقات الويب المتقدمة أو منصات SaaS تبدأ من 25,000 ريال وقد تتجاوز 120,000 ريال للمشاريع المعقدة.",
      },
      {
        h: "العوامل التي تحدد سعر الموقع",
        p: "ستة عوامل أساسية: (1) عدد الصفحات والمكوّنات، (2) تقنية البناء (HTML ثابت، WordPress، React، Next.js)، (3) الربط مع أنظمة خارجية (CRM، بوابات دفع، شحن)، (4) تصميم مخصص أم قالب جاهز، (5) دعم اللغتين العربية والإنجليزية مع RTL، و(6) السرعة والـ SEO التقني. حاسبة برولانسر تسمح لك بالتحكم بكل هذه العوامل.",
      },
      {
        h: "WordPress أم تطوير مخصص؟",
        p: "WordPress أرخص وأسرع في البداية (4,500–12,000 ريال)، مناسب لمواقع تعريفية ومدونات ومتاجر صغيرة. التطوير المخصص بـ React أو Next.js أغلى (10,000–50,000 ريال) لكنه أسرع في التشغيل، أكثر أمانًا، ويسهل توسعته لاحقًا. القاعدة: إذا كان الموقع جزءًا من منتج تقني (مثل منصة أو SaaS)، اذهب للتطوير المخصص.",
      },
      {
        h: "كم يأخذ مطور الويب المستقل في السعودية؟",
        p: "سعر الساعة لمطور الويب المستقل في المملكة 2026 يتراوح: مبتدئ 60–120 ريال، متوسط 120–220 ريال، خبير 220–450 ريال، استشاري متخصص (DevOps، أمان، Fullstack) 450–800 ريال/ساعة. أعلى الأسعار يحصل عليها متخصصو React/Next.js و Node.js و Python الذين يبنون منتجات SaaS سعودية.",
      },
      {
        h: "كيف تستخدم حاسبة برولانسر لتسعير موقع؟",
        p: "اختر 'تطوير مواقع'، حدد خبرتك ومستوى التعقيد (موقع تعريفي = متوسط، تطبيق ويب = معقد)، أدخل عدد الساعات التقديرية (40 ساعة لموقع 5 صفحات، 150+ لتطبيق متوسط)، وفعّل الاستعجال إن طُلب التسليم خلال أسبوعين. ستحصل على سعر ثلاثي الطبقات مع تحليل ذكاء اصطناعي يوضح لك كيف ترفع فرص الفوز بالطلب.",
      },
      {
        h: "كيف تضمن ربحية مشروع الموقع؟",
        p: "أربع قواعد: (1) قسّم المشروع إلى مراحل (Discovery، التصميم، التطوير، الإطلاق) بدفعات محددة، (2) اطلب 30–50% مقدمًا، (3) حدد عدد التعديلات لكل مرحلة، (4) أضف صيانة شهرية (300–1,500 ريال/شهريًا) كمصدر دخل مستمر. العقد الواضح يحميك قانونيًا ويرفع ثقة العميل.",
      },
    ],
    faqs: [
      { q: "كم تستغرق مدة بناء الموقع؟", a: "صفحة هبوط: 5–10 أيام. موقع تعريفي: 3–5 أسابيع. تطبيق ويب متوسط: 2–4 أشهر." },
      { q: "هل السعر يشمل الاستضافة والدومين؟", a: "عادةً لا. ينصح بتضمينهما للعميل كبند منفصل (300–800 ريال/سنة) أو تركهما بإدارته." },
      { q: "هل الحاجة للنسخة العربية ترفع السعر؟", a: "نعم 15–25% إضافي لدعم RTL واختبار الخطوط والتوافق بين اللغتين." },
      { q: "ما نظام الدفعات الأنسب؟", a: "40% مقدم، 30% بعد التصميم، 30% عند الإطلاق — متوازن ومقبول لدى العملاء السعوديين." },
      { q: "هل أضيف ضريبة القيمة المضافة؟", a: "إذا تجاوز دخلك السنوي 375,000 ريال، نعم (15%)؛ وإلا فالخيار لك." },
    ],
  },

  "social-media-management-pricing-saudi": {
    slug: "social-media-management-pricing-saudi",
    service: "marketing",
    h1: "كم سعر إدارة حسابات السوشال ميديا في السعودية؟",
    metaTitle: "أسعار إدارة السوشال ميديا في السعودية | حاسبة العمل الحر — برولانسر",
    metaDesc: "كم تكلفة إدارة حسابات السوشال ميديا الشهرية في السعودية 2026؟ دليل شامل للأسعار على انستغرام، تويتر، سناب، تيك توك مع حاسبة سعر فورية.",
    kw: "أسعار إدارة سوشال ميديا, سعر إدارة حسابات, تسويق إلكتروني السعودية",
    tagline: "دليل تسعير إدارة الحسابات والتسويق الرقمي",
    priceTable: [
      { role: "باقة أساسية (منصة واحدة)", perHour: "1,500–3,500 ريال/شهريًا" },
      { role: "باقة متوسطة (3 منصات)", perHour: "3,500–8,000 ريال/شهريًا" },
      { role: "باقة احترافية + إعلانات", perHour: "8,000–20,000 ريال/شهريًا" },
      { role: "باقة متميزة + تصوير", perHour: "20,000–60,000 ريال/شهريًا" },
    ],
    sections: [
      {
        h: "كم أسعار إدارة السوشال ميديا الشهرية؟",
        p: "تكلفة إدارة حسابات السوشال ميديا في السعودية 2026 تبدأ من 1,500 ريال شهريًا لمنصة واحدة بإدارة بسيطة (12–15 منشورًا شهريًا)، وتصل إلى 60,000+ ريال شهريًا للعلامات التجارية الكبرى التي تحتاج إدارة متعددة المنصات مع إنتاج محتوى فيديو وإدارة حملات إعلانية. المدير المستقل الخبير في المملكة يحقق في المتوسط 15,000–30,000 ريال شهريًا من 3–5 عملاء.",
      },
      {
        h: "ما الذي يحدد السعر؟",
        p: "خمسة عوامل: (1) عدد المنصات (انستغرام، تويتر/X، سناب شات، تيك توك، لينكد إن)، (2) عدد المنشورات الأسبوعية، (3) نوع المحتوى (نص، تصميم، فيديو، Reels)، (4) إدارة الإعلانات الممولة وميزانيتها، (5) تقارير الأداء الشهرية. برولانسر تحسب كل عامل بمعامل محدد ضمن الحاسبة.",
      },
      {
        h: "هل أسعر بالباقة أم بالساعة؟",
        p: "الأفضل بالباقة الشهرية لأن العميل يفضّل سعرًا واضحًا، وأنت تضمن دخلًا ثابتًا وتخطيطًا أفضل. استخدم الحاسبة لتقدير ساعات العمل الشهرية (عادة 30–80 ساعة)، ثم اضربها في سعر ساعتك وأضف 15% هامش للطوارئ. اعرض الباقة بثلاث مستويات (أساسية، متقدمة، متميزة) ليختار العميل.",
      },
      {
        h: "كم أضيف لإدارة الحملات الممولة؟",
        p: "تسعير إدارة الإعلانات له ثلاث طرق في السوق السعودي: (1) رسم ثابت 1,500–5,000 ريال شهريًا، (2) نسبة من الميزانية (10–20% من الإنفاق الإعلاني)، (3) هجين (رسم أساسي + نسبة أداء). الطريقة الهجينة الأكثر عدلًا للطرفين، وتربطك بنتائج العميل.",
      },
      {
        h: "كيف تستخدم الحاسبة لتسعير باقتك؟",
        p: "اختر 'التسويق الرقمي'، حدد خبرتك ومستوى التعقيد (حسابات متعددة = معقد)، أدخل عدد الساعات الشهرية التقديرية (40 ساعة للباقة المتوسطة)، فعّل 'الاستعجال' إن كان العميل يحتاج انطلاقة سريعة. ستحصل على سعر شهري موصى به + سعر الفوز بالعميل.",
      },
      {
        h: "خدمات تضيفها لرفع السعر",
        p: "خمس إضافات تجعل باقتك متميزة وترفع سعرها 30–100%: (1) تصوير شهري احترافي، (2) تحرير فيديو Reels / TikTok، (3) إدارة التفاعلات والردود، (4) تقارير أداء أسبوعية لا شهرية، (5) ورش توعية داخلية لفريق العميل. اذكر هذه الإضافات في العقد كخدمات اختيارية.",
      },
    ],
    faqs: [
      { q: "ما أرخص باقة مقبولة؟", a: "لا تنزل عن 1,200 ريال/شهريًا للمنصة الواحدة، وإلا ستخسر وقتك مقابل عائد ضعيف." },
      { q: "هل أضيف ميزانية الإعلانات داخل الباقة؟", a: "لا، ميزانية الإعلانات يدفعها العميل مباشرة لمنصات الإعلان، وأنت تحصل فقط على رسم الإدارة." },
      { q: "كم عدد المنشورات المناسبة شهريًا؟", a: "12–20 منشورًا للمنصة الأساسية، 8–12 للمنصات المساعدة. الكمية ليست كل شيء — الجودة والتفاعل أهم." },
      { q: "هل أستخدم أدوات مدفوعة في الإدارة؟", a: "نعم (Later, Buffer, Meta Business Suite). اذكر هذه التكلفة في العقد أو ادمجها بالسعر." },
      { q: "متى أرفع سعر الباقة؟", a: "راجع كل 6 أشهر؛ إذا حقق العميل أهدافه، ارفع 10–20% مع تجديد العقد." },
    ],
  },

  "content-writing-pricing-saudi": {
    slug: "content-writing-pricing-saudi",
    service: "content",
    h1: "كم أسعار كتابة المحتوى العربي في السعودية؟",
    metaTitle: "أسعار كتابة المحتوى العربي في السعودية | حاسبة العمل الحر — برولانسر",
    metaDesc: "كم سعر كتابة المحتوى في السعودية 2026؟ دليل شامل لتسعير المقالات، كتابة الإعلانات، السكريبت، والمحتوى التسويقي، مع حاسبة فورية للمستقلين.",
    kw: "أسعار كتابة محتوى, كاتب محتوى السعودية, سعر مقال",
    tagline: "دليل تسعير خدمات كتابة المحتوى والسكريبت",
    priceTable: [
      { role: "مقال 500 كلمة", perHour: "150–450 ريال" },
      { role: "مقال 1000–1500 كلمة", perHour: "300–900 ريال" },
      { role: "محتوى تسويقي (SEO)", perHour: "500–1,500 ريال/مقال" },
      { role: "سكريبت فيديو إعلاني", perHour: "800–3,500 ريال" },
    ],
    sections: [
      {
        h: "ما متوسط سعر كتابة المحتوى العربي في السعودية؟",
        p: "متوسط سعر مقال 500 كلمة في السعودية لعام 2026 يتراوح بين 150 و 450 ريال من كاتب مستقل محترف، ويرتفع إلى 300–900 ريال للمقال من 1000 إلى 1500 كلمة. المحتوى المحسّن لمحركات البحث (SEO) يبدأ من 500 ريال، أما السكريبتات الإعلانية فتتراوح بين 800 و 3,500 ريال للسكريبت الواحد — خصوصًا إذا كان متضمنًا بحث عن الجمهور وتعديلات متعددة.",
      },
      {
        h: "لماذا يختلف السعر بين كاتب وآخر؟",
        p: "ثلاثة عوامل تفسر الفرق: (1) تخصص الكاتب (طب، تقنية، تمويل تدفع أعلى من المحتوى العام)، (2) إتقان التسويق الرقمي والـ SEO يرفع السعر 50–100%، (3) خبرة الكاتب الموثقة بروابط لأعمال سابقة ومعرفة بأدوات مثل Surfer SEO أو Ahrefs. حاسبة برولانسر تضيف معامل لكل هذه العوامل.",
      },
      {
        h: "تسعير بالكلمة أم بالمقال؟",
        p: "في السوق السعودي، التسعير بالمقال هو الأشيع لأنه يسهّل التفاوض ويحمي الكاتب من مطالبات التمديد. التسعير بالكلمة (0.30–1.20 ريال/كلمة) مناسب للمشاريع الكبيرة متعددة المقالات أو عندما يكون العدد غير محدد مسبقًا. الحاسبة تدعم الطريقتين — اختر 'ساعة' أو 'مشروع' حسب تفضيلك.",
      },
      {
        h: "كم يأخذ كاتب المحتوى المستقل في السعودية؟",
        p: "دخل الكاتب المستقل السعودي يتفاوت: مبتدئ 3,000–6,000 ريال شهريًا (10–15 مقالًا بأسعار منخفضة)، متوسط 6,000–15,000 ريال (مزيج من مقالات SEO وسكريبتات)، خبير 15,000–40,000 ريال (3–5 عملاء شهريين بعقود طويلة). القاعدة: التخصص في مجال محدد يضاعف دخلك خلال سنة واحدة.",
      },
      {
        h: "كيف تستخدم الحاسبة لتسعير مقال؟",
        p: "اختر 'كتابة محتوى وترجمة'، حدد خبرتك ومستوى التعقيد (مقال SEO = متوسط، سكريبت متخصص = معقد)، أدخل عدد الساعات (مقال 1000 كلمة يأخذ عادة 3–5 ساعات بين بحث وكتابة ومراجعة)، فعّل الاستعجال إن طُلب تسليم خلال 24 ساعة. ستحصل على سعر مناسب لتقدمه مباشرة للعميل.",
      },
      {
        h: "خدمات تضيفها لرفع قيمة المحتوى",
        p: "ارفع سعرك 40–100% بإضافة: (1) بحث كلمات مفتاحية، (2) تحسين On-page SEO، (3) اقتراح صور وإنفوجرافيك، (4) إدخال المقال على CMS العميل، (5) ضمان رقم مرات القراءة الأولية. هذه الخدمات تحوّلك من 'كاتب' إلى 'استراتيجي محتوى' وتبرّر رسمًا شهريًا أعلى.",
      },
    ],
    faqs: [
      { q: "ما أقل سعر مقبول للمقال؟", a: "لا تنزل عن 100 ريال للمقال 500 كلمة؛ أقل من ذلك يعني ساعة عمل بأقل من الحد الأدنى للأجور." },
      { q: "هل أعطي عينة مجانية؟", a: "نعم فقرة واحدة (100–150 كلمة) تكفي كعينة. تجنّب كتابة مقال كامل مجانًا." },
      { q: "هل أكتب تحت اسم العميل أم باسمي؟", a: "في المحتوى التسويقي الكتابة تحت اسم العميل (Ghost writing) هي القاعدة؛ وتتقاضى 15–25% إضافي مقابل التنازل عن الحقوق." },
      { q: "ما عدد التعديلات المناسب؟", a: "جولتان من التعديلات ضمن السعر، وكل جولة إضافية 15% رسم." },
      { q: "هل أستخدم ChatGPT في الكتابة؟", a: "استخدمه كأداة بحث ومسودة أولى فقط؛ لكن المسؤولية والإبداع يظلان بيدك، والعميل يدفع للأفكار لا للنص الآلي." },
    ],
  },

  "ux-ui-pricing-saudi": {
    slug: "ux-ui-pricing-saudi",
    service: "ux_ui",
    h1: "كم سعر تصميم UI/UX في السعودية؟ 2026",
    metaTitle: "أسعار تصميم UI/UX في السعودية | حاسبة العمل الحر — برولانسر",
    metaDesc: "كم تكلفة تصميم UI/UX للتطبيقات والمواقع في السعودية 2026؟ دليل شامل مع تقدير دقيق لأسعار الواجهات والـ Wireframes والـ Prototypes بالريال السعودي.",
    kw: "أسعار UI UX, تصميم واجهات السعودية, سعر تصميم تطبيق",
    tagline: "دليل تسعير خدمات تصميم تجربة المستخدم والواجهات",
    priceTable: [
      { role: "تصميم Wireframes", perHour: "80–180 ريال/ساعة" },
      { role: "تصميم UI لتطبيق صغير", perHour: "6,000–15,000 ريال" },
      { role: "UX كامل لتطبيق متوسط", perHour: "15,000–45,000 ريال" },
      { role: "Design System احترافي", perHour: "25,000–90,000 ريال" },
    ],
    sections: [
      {
        h: "كم يأخذ مصمم UI/UX مستقل في السعودية؟",
        p: "سعر الساعة لمصمم UI/UX في المملكة 2026 يتراوح بين 100 و 350 ريال حسب الخبرة. المبتدئ 80–150 ريال/ساعة ويركز على Wireframes وتصاميم Figma بسيطة، المتوسط 150–250 ريال/ساعة ويقدم تصاميم قابلة للتفاعل (Prototypes)، والخبير 250–450 ريال/ساعة ويقود مشاريع كاملة من بحث المستخدم إلى Design System.",
      },
      {
        h: "ما الذي يدخل في سعر مشروع UI/UX؟",
        p: "ستة محاور: (1) بحث المستخدم (استبيانات، مقابلات، شخصيات) ويأخذ 15–25% من إجمالي الوقت، (2) هيكل المعلومات والـ User Flow، (3) Wireframes بالأسود والأبيض، (4) تصميم الواجهة بألوان العلامة التجارية، (5) النموذج التفاعلي Prototype في Figma، (6) تسليم ملفات التطوير و Design Tokens. كل محور يسعّر على حدة في حاسبة برولانسر.",
      },
      {
        h: "تصميم تطبيق جديد كامل: كم يكلّف؟",
        p: "تصميم تطبيق موبايل متوسط (10–20 شاشة) من البداية حتى Design System قابل للتسليم للمطوّرين يكلف بين 15,000 و 45,000 ريال في السوق السعودي 2026. يستغرق عادة 4–8 أسابيع. التطبيقات المعقدة (منصات SaaS، تطبيقات مالية، صحية) تبدأ من 45,000 وقد تصل إلى 150,000 ريال لاحتياجها بحث مكثف وامتثال لمعايير أمنية.",
      },
      {
        h: "لماذا يرفض بعض العملاء السعر؟",
        p: "ثلاثة أسباب شائعة: (1) لا يدركون الفرق بين 'تصميم شاشة' و'تجربة مستخدم كاملة'، (2) يقارنون بأسعار من دول أرخص، (3) لا يرون المخرج النهائي. الحل: ارفق Case Study يوضح رحلة مشروع سابق — من البحث إلى الإطلاق إلى الأرقام — ليفهم العميل القيمة. برولانسر توفر لك ملف Case Study جاهز للتخصيص.",
      },
      {
        h: "كيف تستخدم الحاسبة لتسعير مشروع UI/UX؟",
        p: "اختر 'تصميم UI/UX'، حدد خبرتك، اختر 'معقد' للتطبيقات متعددة الشاشات، أدخل عدد الساعات (80–200 ساعة للتطبيق المتوسط)، فعّل الاستعجال إن طُلب التسليم أسرع من المعتاد. ستحصل على سعر ثلاثي الطبقات مع تحليل ذكاء اصطناعي يبرز أهم بنود المشروع.",
      },
      {
        h: "اشتراكات UX الشهرية: فكرة ذكية",
        p: "بدلًا من الاعتماد على مشاريع متفرقة، أطلق اشتراك UX شهري (3,500–12,000 ريال/شهريًا) يتضمن: 20–40 ساعة شهرية من التصميم، أولوية في الرد، مراجعة Design System، ودعم فريق التطوير. هذا النموذج يضمن دخلًا ثابتًا ويحوّل عملائك إلى شراكات طويلة الأمد.",
      },
    ],
    faqs: [
      { q: "هل Figma هو الأداة الوحيدة المطلوبة؟", a: "تقريبًا، لكن إتقان أدوات بحث UX مثل Maze و Hotjar يضاعف قيمتك." },
      { q: "ما الفرق بين UI و UX في التسعير؟", a: "UX أغلى 20–40% لأنه يشمل البحث والتحليل، بينما UI هو التنفيذ البصري." },
      { q: "هل أسلّم ملفات التطوير؟", a: "نعم، تسليم Design Tokens و Spec Sheets ضروري ويبرر 10–15% إضافي من السعر." },
      { q: "كم مدة مشروع التطبيق المتوسط؟", a: "4–8 أسابيع للتصميم الكامل، منها 1–2 أسبوع للبحث." },
      { q: "هل أتضمن تدريب فريق العميل؟", a: "خدمة إضافية رائعة بـ 1,500–3,500 ريال/جلسة." },
    ],
  },

  "video-editing-pricing-saudi": {
    slug: "video-editing-pricing-saudi",
    service: "video",
    h1: "كم أسعار مونتاج الفيديو في السعودية 2026؟",
    metaTitle: "أسعار مونتاج الفيديو في السعودية | حاسبة العمل الحر — برولانسر",
    metaDesc: "كم سعر مونتاج فيديو إعلاني أو Reels أو شورت في السعودية 2026؟ دليل أسعار شامل لمونتير الفيديو المستقل مع حاسبة فورية بالريال السعودي.",
    kw: "أسعار مونتاج فيديو, سعر فيديو إعلاني, مونتير السعودية",
    tagline: "دليل تسعير خدمات تحرير الفيديو والإنتاج الرقمي",
    priceTable: [
      { role: "Reels / Shorts قصير", perHour: "250–800 ريال/فيديو" },
      { role: "فيديو إعلاني 1–2 دقيقة", perHour: "1,500–6,000 ريال" },
      { role: "فيديو موشن جرافيك", perHour: "2,500–12,000 ريال" },
      { role: "فيديو شركات / Case Study", perHour: "5,000–25,000 ريال" },
    ],
    sections: [
      {
        h: "كم سعر مونتاج فيديو في السعودية؟",
        p: "تتفاوت أسعار مونتاج الفيديو في المملكة لعام 2026 بشكل كبير: مقطع Reels أو Short قصير (15–60 ثانية) يتراوح بين 250 و 800 ريال، فيديو إعلاني متوسط (دقيقة إلى دقيقتين) من 1,500 إلى 6,000 ريال، فيديو موشن جرافيك مع Animations من 2,500 إلى 12,000 ريال، وفيديوهات الشركات الكبيرة أو Case Studies تبدأ من 5,000 وقد تصل إلى 25,000 ريال.",
      },
      {
        h: "العوامل التي تحدد السعر",
        p: "خمسة محاور: (1) مدة الفيديو النهائي، (2) كمية المواد الخام (الـ Rushes)، (3) هل العمل مونتاج فقط أم يشمل Motion Graphics و VFX، (4) تلوين احترافي (Color Grading)، (5) موسيقى مرخّصة أو تصميم صوت أصلي. كلما زاد التعقيد، زاد السعر — والحاسبة تضع معاملًا لكل عامل.",
      },
      {
        h: "كم يأخذ مونتير الفيديو المستقل شهريًا؟",
        p: "دخل المونتير المستقل في السعودية 2026: مبتدئ 4,000–8,000 ريال شهريًا (مقاطع Reels وشورتس)، متوسط 8,000–20,000 ريال (مزيج من فيديوهات إعلانية ومحتوى شركات)، خبير 20,000–60,000 ريال (3–5 عملاء شهريين بعقود طويلة الأمد مع إنتاج موشن جرافيك احترافي). المفتاح: الاستثمار في معدات وبرامج احترافية (Premiere، After Effects، DaVinci).",
      },
      {
        h: "تسعير بالفيديو أم بالساعة؟",
        p: "السوق السعودي يفضّل التسعير بالفيديو الواحد لأن العميل يريد معرفة التكلفة الإجمالية مقدمًا. استخدم تسعير الساعة في مرحلة التقدير فقط: متوسط الوقت لمقطع 1 دقيقة هو 6–10 ساعات (استيراد، مونتاج، تلوين، صوت)، اضربها في سعر ساعتك وأضف 20% هامش احتياطي للتعديلات.",
      },
      {
        h: "كيف تضيف قيمة ترفع السعر 50%+؟",
        p: "خمسة إضافات: (1) موشن جرافيك للعناوين والشعارات، (2) ترجمة واحترافية مع Closed Captions، (3) نسخ متعددة الصيغ (Reels، TikTok، YouTube، Twitter)، (4) تلوين سينمائي بـ DaVinci، (5) تصميم صوتي بـ Foley وموسيقى مخصصة. كل إضافة تبرر 10–30% إضافي.",
      },
      {
        h: "كيف تستخدم حاسبة برولانسر؟",
        p: "اختر 'مونتاج وفيديو'، حدد خبرتك، اختر 'متوسط' أو 'معقد' حسب تضمين Motion Graphics، أدخل عدد الساعات (10 ساعات لفيديو إعلاني متوسط، 40+ لفيديو موشن جرافيك)، فعّل الاستعجال إن كان العميل يحتاج التسليم خلال 72 ساعة. ستحصل على سعر فوري + نصائح لرفع الهامش.",
      },
    ],
    faqs: [
      { q: "كم تعديل مجاني يجب أن يشمله السعر؟", a: "جولتان من التعديلات؛ وكل جولة إضافية 15–20% من قيمة الفيديو." },
      { q: "هل أتضمن حقوق الموسيقى؟", a: "ليس عادةً — يفضّل العميل شراء الترخيص باسمه. وضّح ذلك في العقد." },
      { q: "ما أنسب تنسيق تسليم؟", a: "MP4 بدقة 4K + 1080p + نسخة عمودية 9:16، وملف المشروع (Project File) حسب الطلب برسم إضافي." },
      { q: "هل أستخدم مواد Stock؟", a: "نعم، لكن اذكر ذلك مسبقًا وأضف تكلفة الترخيص للعميل." },
      { q: "متى أرفع سعري؟", a: "بعد 20 مشروعًا منفذًا أو عند استلام أول عميل شركات كبيرة." },
    ],
  },

  "ecommerce-pricing-saudi": {
    slug: "ecommerce-pricing-saudi",
    service: "web_dev",
    h1: "كم تكلفة تطوير متجر إلكتروني في السعودية 2026؟",
    metaTitle: "تكلفة تطوير متجر إلكتروني في السعودية | حاسبة العمل الحر — برولانسر",
    metaDesc: "كم تكلفة إنشاء متجر إلكتروني في السعودية 2026؟ أسعار Shopify وسلة وزد و WooCommerce وأنظمة مخصصة مع حاسبة سعر فورية للمستقلين.",
    kw: "تكلفة متجر إلكتروني, سعر إنشاء متجر, متجر Shopify السعودية",
    tagline: "دليل أسعار إنشاء المتاجر الإلكترونية في السوق السعودي",
    priceTable: [
      { role: "متجر سلة / زد (قالب)", perHour: "2,500–8,000 ريال" },
      { role: "متجر Shopify مخصص", perHour: "5,000–20,000 ريال" },
      { role: "WooCommerce متقدم", perHour: "8,000–30,000 ريال" },
      { role: "منصة مخصصة (Headless)", perHour: "40,000–180,000 ريال" },
    ],
    sections: [
      {
        h: "كم تكلفة إنشاء متجر إلكتروني في السعودية؟",
        p: "تكلفة تطوير متجر إلكتروني في المملكة لعام 2026 تختلف حسب التقنية: متجر على 'سلة' أو 'زد' بقالب جاهز يبدأ من 2,500 إلى 8,000 ريال، متجر Shopify مع تخصيصات بين 5,000 و 20,000 ريال، متجر WooCommerce متقدم (ووردبريس + ووكومرس) من 8,000 إلى 30,000 ريال، أما المنصات المخصصة Headless Commerce بـ Next.js أو Shopify Plus تبدأ من 40,000 وقد تصل إلى 180,000 ريال.",
      },
      {
        h: "أي منصة تختار لعميلك؟",
        p: "القاعدة: ابدأ بالأبسط للعميل الأول. 'سلة' و 'زد' مثالية للمبتدئين السعوديين (دعم عربي، شحن محلي، مدى، تمارا، تابي) ولا تحتاج صيانة. Shopify الأفضل للعلامات التي تستهدف العالم. WooCommerce مثالي للمنتجات غير التقليدية (اشتراكات، منتجات رقمية). Headless فقط للمشاريع الكبيرة بميزانية 40,000+ ريال.",
      },
      {
        h: "ما العناصر التي تدخل في السعر؟",
        p: "ثمانية بنود: (1) تصميم الواجهة والهوية، (2) ربط بوابة دفع (مدى، فيزا، Apple Pay، تمارا، تابي)، (3) تكامل الشحن (أرامكس، SMSA، سمارت)، (4) الفوترة الإلكترونية (ZATCA)، (5) إعدادات الضريبة (15%)، (6) رفع المنتجات (أول 50 منتجًا)، (7) تدريب فريق العميل، (8) صيانة شهرية. حاسبة برولانسر تحسب هذه البنود منفصلة.",
      },
      {
        h: "فوترة ZATCA: نقطة لا يجب تجاهلها",
        p: "منذ 2022 كل متجر إلكتروني يبيع في السعودية ملزم بالفاتورة الإلكترونية المتوافقة مع هيئة الزكاة والضريبة والجمارك ZATCA. تضمين هذا الربط في العقد يرفع السعر 1,500–4,500 ريال لكنه يحمي العميل قانونيًا ويفتح لك سوقًا للخبرات القانونية التجارية. اذكره بوضوح.",
      },
      {
        h: "كيف تستخدم الحاسبة لتسعير متجر؟",
        p: "اختر 'تطوير مواقع'، حدد خبرتك، اختر 'معقد' للمتاجر المخصصة أو 'متوسط' لقوالب Shopify، أدخل عدد الساعات (40 ساعة لمتجر سلة، 80–150 لمتجر Shopify مخصص، 250+ لمتجر Headless)، فعّل الاستعجال إن طُلب إطلاق سريع قبل الحملات الموسمية (رمضان، اليوم الوطني، الجمعة البيضاء).",
      },
      {
        h: "كيف تضمن ربحية مستمرة؟",
        p: "لا تعتمد على السعر الأولي للمشروع فقط. اعرض على العميل ثلاث قنوات إضافية: (1) باقة صيانة شهرية (800–3,000 ريال/شهريًا)، (2) تحسين SEO ربع سنوي (2,500–8,000 ريال)، (3) تطوير مميزات جديدة بالساعة (120–350 ريال). هذه القنوات تحوّل مشروعًا واحدًا إلى دخل متكرر يستمر لسنوات.",
      },
    ],
    faqs: [
      { q: "ما أرخص خيار لعميل مبتدئ؟", a: "متجر 'سلة' بقالب جاهز بـ 2,500–4,000 ريال كبداية، ثم ترقية لاحقًا." },
      { q: "هل أتضمن رفع المنتجات؟", a: "رفع أول 20–50 منتجًا ضمن السعر؛ ما بعدها 5–15 ريال/منتج." },
      { q: "كم مدة إنشاء المتجر؟", a: "أسبوع لمتجر 'سلة'، 3–5 أسابيع لـ Shopify مخصص، 2–4 أشهر لمتجر Headless." },
      { q: "ما أهم بوابة دفع لعميل سعودي؟", a: "ترتيب الأهمية: مدى، Apple Pay، فيزا/ماستر، تمارا، تابي، STC Pay." },
      { q: "هل أتضمن إعلانات افتتاح المتجر؟", a: "خدمة منفصلة؛ اعرضها كباقة إضافية بـ 2,000–8,000 ريال." },
    ],
  },
};

export const LANDING_SLUGS = Object.keys(LANDING_PAGES);

export function getLanding(slug) {
  return LANDING_PAGES[slug] || null;
}
